<template>
  <v-card flat>
    <v-text-field
      :value="currentCase ? currentCase.name : ''"
      readonly
      outlined
      placeholder="Select case"
      dense
      class="pt-0 mb-0"
      color="primary"
      :messages="disableUrlInput ? null : 'a'"
      :loading="isGetCasePending"
      :rules="rules"
    >
      <template #append-outer>
        <DialogForm
          title="Open Case"
          submit-text="open"
          :disable-submit="!caseToOpen.id"
          :submit="openCase(caseToOpen)"
          :max-width="0"
          :dialog-props="{ width: 'unset' }"
        >
          <template #activator="{ on }">
            <v-btn v-if="!browseBtnSmall" outlined color="primary" small v-on="on">Browse</v-btn>
            <v-btn v-else color="primary" small v-on="on" icon>
              <v-icon>mdi-folder-open-outline</v-icon>
            </v-btn>
          </template>
          <template #default>
            <FolderTreeSelect v-model="caseToOpen" show-cases select-only="case"></FolderTreeSelect>
          </template>
        </DialogForm>
      </template>
      <template v-if="!disableUrlInput" #message>
        <div class="text-caption">
          <a @click="showURLField = !showURLField">Use case link</a>
        </div>
      </template>
    </v-text-field>
    <v-form v-model="isValidURL">
      <v-text-field
        v-if="showURLField"
        v-model="url"
        dense
        outlined
        placeholder="Paste case url"
        class="mx-4"
        :rules="urlRules"
      >
        <template #append-outer>
          <v-btn outlined color="primary" small @click="submitUrl" :disabled="!isValidURL">
            Ok
          </v-btn>
        </template>
      </v-text-field>
    </v-form>
  </v-card>
</template>

<script>
import { makeGetMixin } from "feathers-vuex";

export default {
  name: "InputSelectCase",
  components: {
    DialogForm: () => import("@/components/DialogForm.vue"),
    FolderTreeSelect: () => import("@/components/FolderTreeSelect.vue"),
  },
  mixins: [
    makeGetMixin({
      service: "cases",
      id: "caseId",
      item: "currentCase",
      watch: true,
      queryWhen: "caseId",
    }),
  ],
  props: {
    value: { type: [String, Number, Object], required: false, default: null },
    rules: { type: Array, required: false, default: () => [] },
    browseBtnSmall: { type: Boolean, required: false, default: false },
    disableUrlInput: { type: Boolean, required: false, default: false },
  },
  data() {
    return {
      caseToOpen: {},
      showURLField: false,
      isValidURL: false,
      url: "",
      urlRules: [
        (v) => {
          const regex = new RegExp(
            /[(http(s)?)://(www.)]{2,12}(analytics)[a-z.]{0,15}\.(acelerex.com)\b([a-zA-Z0-9#?&//=]*)(case\/)([0-9]{1,})([a-zA-Z0-9#?&//=]*)/
          );
          return regex.test(v) || "Enter a valid URL";
        },
      ],
      caseParams() {
        return {
          query: {
            $select: ["name", "id"],
          },
        };
      },
    };
  },
  computed: {
    caseId() {
      return this.value;
    },
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    openCase(caseToOpen) {
      return () => {
        this.$emit("input", caseToOpen.id.toString());
        return Promise.resolve();
      };
    },
    submitUrl() {
      const [caseId] = this.url.match(/(case\/)([0-9]{1,})/g);
      const id = caseId.slice(caseId.indexOf("/") + 1);
      this.$emit("input", id);
      this.showURLField = false;
      this.url = "";
    },
  },
};
</script>

<style></style>
